import * as Sentry from '@sentry/react'
import React from 'react'

import ErrorFallback from '@/components/error-callback'

const ErrorBoundary = Sentry.ErrorBoundary as unknown as React.ComponentType<{
  children?: React.ReactNode
  fallback: (props: { error: unknown }) => React.ReactElement
}>

export default function SentryProvider({
  children,
}: {
  children: React.ReactNode
}) {
  return (
    <ErrorBoundary
      fallback={({ error }: { error: unknown }) => {
        return <ErrorFallback error={String(error) || 'Unknown error'} />
      }}
    >
      {children}
    </ErrorBoundary>
  )
}
